const a = "_loader_awtnh_1", e = {
  loader: a
};
export {
  e as default,
  a as loader
};
